import classNames from "classnames";
import { PropsWithChildren, ReactNode } from "react";
import style from "./PageWithActions.module.scss";

export type PageWithActionsProps = {
  actions: ReactNode;
  /**
   * Fixe la barre d'actions en bas de l'écran (position fixed) au lieu de
   * l'afficher dans le flux via une grille pleine hauteur. À utiliser quand le
   * template est déjà un enfant flex d'un conteneur pleine hauteur.
   */
  fixedActions?: boolean;
} & PropsWithChildren;

export function PageWithActions({
  children,
  actions,
  fixedActions = false,
}: PageWithActionsProps) {
  return (
    <div className={classNames(style.template, { [style.fixed]: fixedActions })}>
      <div className={style.scrollablePart}>{children}</div>

      {actions && <div className={style.actions}>{actions}</div>}
    </div>
  );
}
